function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLeafFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.843c-.579 0-1.053.466-1.053 1.035v19.087c0 .57.474 1.035 1.053 1.035s1.053-.466 1.053-1.035V10.878c0-.57-.474-1.035-1.053-1.035z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.221 18.308a1.063 1.063 0 00-1.458.29A4.538 4.538 0 0116 20.584a4.532 4.532 0 01-3.763-1.986c-.321-.471-.98-.6-1.458-.285-.484.316-.61.962-.29 1.433A6.654 6.654 0 0016 22.65a6.654 6.654 0 005.51-2.903 1.03 1.03 0 00-.294-1.438h.005zM19.784 12.611a1.067 1.067 0 00-1.458.285A2.796 2.796 0 0116 14.122a2.8 2.8 0 01-2.326-1.232c-.321-.47-.98-.6-1.458-.284-.484.316-.61.962-.29 1.433a4.92 4.92 0 004.08 2.147 4.92 4.92 0 004.078-2.147 1.03 1.03 0 00-.294-1.438l-.006.01z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.663 1.228a1.067 1.067 0 00-1.32 0C14.915 1.564 5 9.528 5 17.112c0 5.961 4.937 10.815 11 10.815s11-4.854 11-10.814c0-7.586-9.916-15.549-10.337-15.885zM16 25.857c-4.905 0-8.895-3.922-8.895-8.744C7.105 11.54 13.9 5.216 16 3.396c2.1 1.821 8.895 8.139 8.895 13.716 0 4.823-3.99 8.745-8.895 8.745z",
    fill: props.color
  }));
}

export default SvgIconLeafFilled;